import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { TimeSlot } from '../db/time-slot.js';
import { addOpenTimeSlotResolver, removeOpenTimeSlotResolver } from '../server/resolver.js';

export const addOpenTimeSlot = registerMutation({
  operationName: 'addOpenTimeSlot',
  resolve: addOpenTimeSlotResolver,
  type: type => Int,
  params: [{ type: () => TimeSlot, name: 'timeSlot' }],
});

export const removeOpenTimeSlot = registerMutation({
  operationName: 'removeOpenTimeSlot',
  resolve: removeOpenTimeSlotResolver,
  type: type => Boolean,
  params: [{ type: () => String, name: 'timeSlotID' }],
});
